import { useState } from 'react';
import { useAuth } from '../auth';
import { useAction } from '../hooks';
import { MessageErreur } from '../components/ui';
import Logo from '../components/Logo';

export default function Connexion() {
  const { connexion } = useAuth();
  const { executer, enCours, erreur } = useAction();
  const [identifiant, setIdentifiant] = useState('');
  const [motDePasse, setMotDePasse] = useState('');

  const soumettre = (e) => {
    e.preventDefault();
    executer(() => connexion(identifiant, motDePasse));
  };

  return (
    <div className="page-connexion">
      <aside className="connexion-vitrine">
        <div className="connexion-marque">
          <Logo taille={44} />
          <span>SoftManage</span>
        </div>
        <div>
          <h2>Le parc logiciel du cabinet, tenu comme une comptabilité.</h2>
          <p>Clients, postes, licences et mises à jour : un suivi rigoureux, à jour et traçable.</p>
        </div>
        <Logo taille={260} className="connexion-motif" />
        <small>© {new Date().getFullYear()} · Département informatique du cabinet</small>
      </aside>
      <form className="carte carte-connexion" onSubmit={soumettre}>
        <Logo taille={40} className="connexion-logo-mobile" />
        <h1>Connexion</h1>
        <p className="muted">Accédez à l'espace de gestion du cabinet</p>
        <MessageErreur erreur={erreur} />
        <label className="champ">
          <span>Email ou nom d'utilisateur</span>
          <input value={identifiant} onChange={(e) => setIdentifiant(e.target.value)} autoComplete="username" autoFocus required />
        </label>
        <label className="champ">
          <span>Mot de passe</span>
          <input
            type="password"
            value={motDePasse}
            onChange={(e) => setMotDePasse(e.target.value)}
            autoComplete="current-password"
            required
          />
        </label>
        <button className="btn btn-principal" disabled={enCours}>
          {enCours ? 'Connexion…' : 'Se connecter'}
        </button>
      </form>
    </div>
  );
}
